import { compact, flow, get, isEmpty, map, reduce, uniq } from 'lodash/fp';
import getParentProductId from '@ahmdigital/logic/lib/utils/get-parent-product-id';

import { ProductType } from '../../../src/client/types/product';
import constants from '../../../src/client/ahm-constants';
import fetchProductExcess from '../../../src/client/utils/fetch-product-excess';

const getParentProductIds = ({ products }: { products: Record<string, ProductType> | null }) =>
  flow([
    map((product) => {
      const productId = get('id', product);
      const softBundleHospitalId = get(`${productId}.hospital`, constants.COMBINED_PRODUCT_COMPONENTS);
      const idToGetParent = softBundleHospitalId || productId;
      return getParentProductId(idToGetParent);
    }),
    uniq,
    compact,
  ])(products);

const getProductIdsWithExcess = async (products: Record<string, ProductType> | null) => {
  const parentProductIds = getParentProductIds({ products });

  const excessByParentPromises = map((parentProductId) => fetchProductExcess({ parentProductId }), parentProductIds);

  const excessByParentProducts = await Promise.all(excessByParentPromises);
  return isEmpty(excessByParentProducts)
    ? null
    : reduce((parentObj, excessObj: object) => ({ ...parentObj, ...excessObj }), {}, excessByParentProducts);
};

export default getProductIdsWithExcess;
